'use client';

import { AppImageClient } from '@components/appImage';
import { Typography } from '@components/typography';
import { cn } from '@lib/utils/cn';
import Link from 'next/link';

import { ProductCardProps } from './types';

import { IconArrowRightCorner24 } from '@/shared/icons/24/IconArrowRightCorner24';

export const ProductCard = ({
  title,
  image,
  description,
  href,
  className,
}: ProductCardProps) => {
  const desktopClassName = cn(
    'absolute object-cover transition-opacity duration-300 group-hover:opacity-0 lg:block',
    image.className,
  );
  const mobileClassName = 'relative mb-4 h-auto w-full lg:hidden';

  const mobileData = image.dataMobile ?? image.dataWeb;
  const mobileSize = image.dataMobile ? image.sizeMobile : image.sizeWeb;

  return (
    <Link
      href={href}
      className={`group rounded-16 bg-surface-base-secondary relative overflow-hidden transition-all duration-300 ${className || ''}`}
    >
      {/* Фоновое изображение для desktop */}
      {/* w-auto: класс из конфига задаёт только высоту, ширина должна
          считаться по аспекту, а не браться из атрибута width */}
      <AppImageClient
        {...image.dataWeb}
        width={image.sizeWeb?.width}
        height={image.sizeWeb?.height}
        alt={image.alt ?? ''}
        className={cn('w-auto', desktopClassName)}
      />

      {/* Контент */}
      <div className="relative flex h-full flex-col justify-end p-7 max-sm:p-2 max-sm:pb-6">
        {/* Мобильное изображение */}
        <AppImageClient
          {...mobileData}
          width={mobileSize?.width}
          height={mobileSize?.height}
          alt={image.alt ?? ''}
          className={mobileClassName}
        />

        {/* Текстовый контент с анимацией */}
        <div className="relative z-10 flex flex-col gap-2 transition-transform duration-300 lg:translate-y-full lg:group-hover:translate-y-0">
          {/* Заголовок нетипичный, под общую типографику не подходит! */}
          <h6 className="flex items-center gap-2 text-[18px] leading-[28px] font-medium transition-transform duration-300 max-sm:text-[24px] max-sm:leading-[28px] max-sm:tracking-[-0.24px] lg:-translate-y-full lg:group-hover:translate-y-0">
            {title}
            <IconArrowRightCorner24 className="rotate-45 transition-transform duration-300 group-hover:rotate-0" />
          </h6>

          {description && (
            <Typography variant="text-m">{description}</Typography>
          )}
        </div>
      </div>
    </Link>
  );
};
